
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b2c-d2c-stack",
      function () {
        return require("private-next-pages/b2c-d2c-stack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b2c-d2c-stack"])
      });
    }
  